import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ShowMultiplicadorService {
  private showMultiplicador = signal(false);
  private multiplicador = signal<number>(0);


  setShowMultiplicador(value: boolean) {
    this.showMultiplicador.set(value);
  }

  getShowMultiplicador(): boolean {
    // console.log('mostrando modal o no multiplicador',this.multiplicador());

    if (this.multiplicador() >= 1.20) {
      this.showMultiplicador.set(true);
    } else {
      this.showMultiplicador.set(false);
    }
    return this.showMultiplicador();
  }

  setMultiplicador(value: number) {
    // console.log('valor del multiplicador EN EL SERVICIO', value);
    this.multiplicador.set(value);
  }
}


